const ToolboxRessources = (target) => {
  const initToolbox = el => {
    const params = {}
    const linkEl = el.querySelector('.toolbox-widget__button')
    const baseURL = linkEl.href
    $(el).find('.toolbox-widget__input').on('change', e => {
      const target = e.currentTarget
      const name = target.name
      let index = 0
      let finalUrl = baseURL
      const values = $(`input[name="${name}"]:checked`).map( function() {
        return this.value
      }).get().join(',')
      params[name] = values

      for (let key in params) {
        if (params.hasOwnProperty(key)) {
          finalUrl +=  index === 0 ? `?${key}=${params[key]}` : `&${key}=${params[key]}`
          index++
        }
      }
      linkEl.href = finalUrl
    })
  };

  $('body').find(target)
    .each((_, el) => {
      initToolbox(el);
    });
}

export default ToolboxRessources;



// WEBPACK FOOTER //
// ./scripts/components/ToolboxRessources.js